import React from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import CardSection from "./CardSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/reservas",
    label: "Reservas por Tipo",
  },
  {
    path: "/reservas/spa",
    label: "Reserva Spa",
    isActive: true,
  },
];

function ReservasSpa() {
  return (
    <Page
      title="Reservas de Spa"
      description="Acciones en reservas de Spa."
      breadCrumbs={breadCrumbs}
    >
      <CardSection />
    </Page>
  );
}

export default ReservasSpa;
